import React from "react";

import styles from "./ButtonSave.module.css";

const ButtonSave = function (props) {
  return (
    <button className={styles["btn"]} disabled={props.disabled}>
      <span className={styles["btn__text"]}>
        SAVE
        <div className={styles["btn__icon"]}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="2 4 20 17"
            stroke="currentColor"
            strokeWidth={1}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
            />
          </svg>
        </div>
        CARD
      </span>
    </button>
  );
};

export default ButtonSave;
